import { IClientFetch, IOrderForClient } from "src/models/IOrder";

export enum ClientActionEnum {
  REQUEST_CLIENT = "REQUEST_CLIENT",
  RESULT_CLIENT = "RESULT_CLIENT",

  REQUEST_CLIENT_PAY = 'REQUEST_CLIENT_PAY',
  RESULT_CLIENT_PAY = 'RESULT_CLIENT_PAY',

  REQUEST_SIGNUP = "REQUEST_SIGNUP",
  RESULT_SIGNUP = "RESULT_SIGNUP",

  REQUEST_LOGIN = "REQUEST_LOGIN",
  RESULT_LOGIN = "RESULT_LOGIN",
  ERROR_LOGIN = 'ERROR_LOGIN',
  EXIT = "EXIT",
}

export interface ClientState {
  client?: IClientFetch;
  orderList?: IOrderForClient[];
  isLogin: boolean;
  id: number | null;
  isLoading: {
    login: boolean,
    signup: boolean,
    get: boolean,
    pay: boolean,
  };
  result: {
    login?: number | string;
    signup?: any;
    get?: any;
    pay?: string;
  };
}

export interface RequestPayNowAction {
  type: ClientActionEnum.REQUEST_CLIENT_PAY;
  id: number;
}

export interface ResultPayNowAction {
  type: ClientActionEnum.RESULT_CLIENT_PAY;
  data: string;
  status: string | number
}

export interface RequestClientAction {
  type: ClientActionEnum.REQUEST_CLIENT;
  id: string;
}

export interface ResultClientAction {
  type: ClientActionEnum.RESULT_CLIENT;
  data: any;
  status: string | number
}

export interface SignupAction {
  type: ClientActionEnum.REQUEST_SIGNUP;
  email: string;
}

export interface ResultSignupAction {
  type: ClientActionEnum.RESULT_SIGNUP;
  status: number | string;
  user: { id: number }
}

export interface LoginAction {
  type: ClientActionEnum.REQUEST_LOGIN;
  login?: {
    email: string;
    password: string;
  };
  token?: string;
}

export interface ResultLoginAction {
  type: ClientActionEnum.RESULT_LOGIN;
  token: string;
  status: number | string;
  id: number;
}

export interface ErrorLoginAction {
  type: ClientActionEnum.ERROR_LOGIN;
  result: string;
}

export interface ExitLoginAction {
  type: ClientActionEnum.EXIT;
  result?: string;
}

export type ClientAction =
  | RequestClientAction
  | ResultClientAction
  | LoginAction
  | ResultLoginAction
  | ErrorLoginAction
  | ExitLoginAction
  | SignupAction
  | ResultSignupAction
  | RequestPayNowAction
  | ResultPayNowAction;
